module.exports = __webpack_public_path__ + "static/media/play-y.b2b38ce2.png";